/**
 * Metadata service handler.
 *
 * Fetches the server-side application configuration after successful login.
 * The response is dispatched as `"UPDATE_METADATA"` which is processed by
 * `metadata-middleware.ts` to hydrate the Redux `metadata` and `watchlist`
 * slices in a single saga-driven update.
 */
import { getMethod } from "./rest-handler";
import { store } from "@store/index";

/**
 * Fetch application metadata from `GET /metadata` and dispatch the result.
 *
 * Sets up watchlists, branding, license details, and the full instrument
 * catalogue used by the market-watch and symbol-search components.
 */
export const getMetadata = () => {
  return new Promise<void>((resolve, reject) => {
    getMethod("metadata")
      .then((response) => {
        const metadata = response["data"];
        store.dispatch({
          type: "UPDATE_METADATA",
          payload: {
            metadata,
          },
        });
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
  });
};
